import { useState } from 'react';

import Button from './Button';
import Modal from './Modal';

import { ActionTypeManageFCupEnum } from '@/services/friendsCup';

interface GenericModalTkredProps {
  data: any;
  handleRequestActions: (
    actionType: number,
    idMiniLiga?: number
  ) => Promise<any>;
}

export default function ModalTkred({
  data,
  handleRequestActions,
}: Readonly<GenericModalTkredProps>) {
  const postLoginTkred = JSON.parse(data);
  const [isOpen, setIsOpen] = useState(postLoginTkred.isOpenModal);

  const handleCloseInvitationModal = () => {
    setIsOpen(false);
    sessionStorage.removeItem('postLoginTkred');
  };

  return (
    <>
      {/* MODAL PARA INVITACIONES DESDE TKRED */}
      <Modal
        closeOutside={false}
        controlledOnClose={handleCloseInvitationModal}
        isControlledOpen={isOpen}
        render={() => {
          return (
            <div className="space-y-10 mb-6">
              <p className="text-base text-[#666666] text-center">
                ¿Querés aceptar la invitación a{' '}
                {`'${
                  postLoginTkred.data.postLogin.nombreTA ||
                  postLoginTkred.data.postLogin.nombreCopaAmigos ||
                  postLoginTkred.data.postLogin.nombreML
                }'`}
                ?
              </p>
              <div className="flex space-x-2 my-6">
                <Button
                  className="flex-1 !bg-[#EEF2FF] !text-[#3366FF] hover:!bg-[#E5E9FF]"
                  type="button"
                  variant="secondary"
                  onClick={() => {
                    setIsOpen(false);
                    sessionStorage.removeItem('postLoginTkred');
                  }}
                >
                  Rechazar
                </Button>
                <Button
                  className="flex-1 !bg-[#3366FF] hover:!bg-[#2952CC]"
                  type="button"
                  variant="primary"
                  onClick={() => {
                    handleRequestActions(
                      ActionTypeManageFCupEnum.ACC_ACEPTAR_INVITACION,
                      postLoginTkred.data.postLogin.idParamInvitacion
                    );
                    setIsOpen(false);
                    sessionStorage.removeItem('postLoginTkred');
                  }}
                >
                  Aceptar
                </Button>
              </div>
            </div>
          );
        }}
        showCloseButton={false}
        size="xs"
        variant="controlled"
      />
    </>
  );
}
